import { useRouter } from 'next/router';
import { Button, Typography } from 'ui';
import { Color, TypeScales } from 'ui/primitives';
import s from './UnderPriceCard.module.scss';
import { useState } from 'react';
import TestDrivePopup from '../../../popups/TestDrivePopup';
import { useSelector } from 'react-redux';
import { useNativeAuth } from 'auth/hooks/useNativeAuth';
import cn from 'classnames';
import { getDefaultAttributes, trackEvent } from 'core-lib/utils/events';

export const UnderPriceCars = ({ content }: { content: any }) => {
  const [selectedModel, setSelectedModel] = useState(null);
  const router = useRouter();
  const { isAuthenticated } = useSelector((state: any) => state?.auth);
  const { login } = useNativeAuth();

  const checkAuth = async (callback) => {
    if (isAuthenticated) {
      callback();
    } else {
      const res = await login();
      if (res) {
        callback();
      }
    }
  };
  const handleBookClick = (car) => {
    checkAuth(() => {
      setSelectedModel(car?.modelId);
    });
    trackEvent({
      name: 'cta_clicked',
      defaultAttr: getDefaultAttributes(),
      attributes: {
        category: 'Services',
        subcategory: 'Test Drive',
        cta_name: 'book test drive',
        page_name: 'new_cars_web',
      },
    });
  };
  return (
    <>
      {content?.similarCars?.length > 0 && (
        <div className={s.root}>
          <>
            <Typography
              className={s.heading}
              label={'Similar Cars'}
              variant={TypeScales.h2}
            />
            <div className={s.cards_list}>
              {content?.similarCars?.map((car, idx) => {
                return (
                  <div
                    key={idx}
                    className={s.card_wrapper}
                    onClick={() =>
                      router.push(
                        `/new-cars/${car?.brandSlug}-car/${car?.modelSlug}`
                      )
                    }
                  >
                    <div className={s.card_image}>
                      <img
                        src={car?.image}
                        alt={`${car?.brandSlug}-car/${car?.modelSlug}-image`}
                      />
                    </div>
                    <div className={s.card_price}>
                      <Typography
                        variant={TypeScales.h4}
                        label={car?.name}
                        className={s.car_name}
                      />
                      <Typography
                        label={car?.priceRange}
                        variant={TypeScales.base_big_m}
                        color={Color.text_subheading}
                      />
                    </div>
                    <div className={s.btn}>
                      <Button
                        label="Book Test Drive"
                        fullwidth
                        onClick={(e) => {
                          e.stopPropagation();
                          handleBookClick(car);
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        </div>
      )}
      {!!selectedModel && (
        <TestDrivePopup
          modelId={selectedModel}
          show={!!selectedModel}
          onClose={() => {
            setSelectedModel(null);
          }}
        />
      )}
    </>
  );
};
